import request from "./axios";
import {aisinoConfirmModal} from "../modal/AisinoModalMethod";
import {siteIndex} from "../../index";
import {Modal} from 'antd';
import {commonLan} from "../../source/js/common";
//增加请求配置的loading，默认可不传，不传默认true,传false不加载loading
//post异步请求
let isRepeat = true;
// 请求池 控制并发请求数量  开始
class RequestPool {
    constructor(max = 5) {
        this.max = max;
        this.queue = [];
        this.activeCount = 0;
    }

    add(requestFn) {
        return new Promise((resolve, reject) => {
            const task = () => {
                this.activeCount++;
                requestFn()
                    .then(resolve)
                    .catch(reject)
                    .finally(() => {
                        this.activeCount--;
                        this._next();
                    });
            };
            this.activeCount < this.max ? task() : this.queue.push(task);
        });
    }

    _next() {
        this.queue.length && this.queue.shift()();
    }
}
const pool = new RequestPool(5);
// 请求池 控制并发请求数量  结束

export function post(url,data,loading) {
    return pool.add(()=> {
        return (request({
            url:url,
            async:true,
            method:'post',
            loading:loading,
            data:data
        }).catch(error =>{
            setTimeout(()=>{
                overtime()
            },9000)
        }))
    })
}
//post同步请求
export function postSync(url,data,loading,businessExpFun) {
    return pool.add(()=> {
        return (request({
            url: url,
            async: false,
            method: 'post',
            loading: loading,
            data: data,
            businessExpFun: businessExpFun//业务异常 回调方法
        }).catch(error => {
            setTimeout(() => {
                overtime()
            }, 9000)
        }))
    })
}
//post
export function postQuery(url,params,loading) {
    return (request({
        url:url,
        method:'post',
        loading:loading,
        params:params
    }).catch(error =>{
        setTimeout(()=>{
            overtime()
        },9000)
    }))
}
//get请求
export function get(url,params,loading) {
    return (request({
        url:url,
        method:'get',
        loading:loading,
        params:params
    }).catch(error =>{
        setTimeout(()=>{
            overtime()
        },9000)
    }))
}
//如果所有接口突然报错那么提示Network connection is failed!并关闭loading加载DOM
function overtime() {
    const loadingDiv = document.getElementById('loading');
    if(isRepeat && loadingDiv){
        Modal.error({
          content: commonLan.networkFailed.label,
        });
        if(loadingDiv){
            document.body.removeChild(document.getElementById('loading'));
        }
        isRepeat = false
    }
  }
//获取后台返回图片流的方法
export function getImg(url,params,loading) {
    return (request({
        url:url,
        method:'get',
        params:params,
        loading:loading,
        responseType: 'blob' //必须说明 axios 请求类型
    }).catch(error =>{
    }))
}
export function sitePost(url, data, reFunction,flag) {
    request({
        url:"aisino/survey/checkUrlHaveSurvey",
        method:'post',
        data:{url:url}
    }).then(resData=>{
        //如果需要参与问卷调查 打开问卷调查页面
        if (resData.reBoolean === true) {
            postSync("aisino/survey/saveSurveyAcknowledge",{menuId:resData.menuId,surveyReleaseId:resData.surveyReleaseId});
            aisinoConfirmModal(commonLan.satisfactionSurvey.label,"",function(){
                siteIndex.refs.surveyForm.handleQuestionInfo(resData,function(){
                    if(flag){
                        reFunction();
                    }else{
                        postSync(url,data).then(response=>{
                            if (reFunction != null) {
                                reFunction(response);
                            }
                        })
                    }
                });
            },function(){
                if(flag){
                    reFunction();
                }else{
                    postSync(url,data).then(response=>{
                        if (reFunction != null) {
                            reFunction(response);
                        }
                    })
                }
            })
        }else{
            if(flag){
                reFunction();
            }else{
                postSync(url,data).then(response=>{
                    if (reFunction != null) {
                        reFunction(response);
                    }
                })
            }
        }
    }).catch(error =>{
        if(flag){
            reFunction();
        }else{
            postSync(url,data).then(response=>{
                if (reFunction != null) {
                    reFunction(response);
                }
            })
        }
    })
}
